import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { FaShieldAlt, FaDatabase, FaFileAlt, FaGavel, FaUserShield, FaCookieBite, FaServer, FaEnvelope, FaSyncAlt } from 'react-icons/fa'

const Privacy = () => {
  const { t } = useTranslation()

  const sections = [
    {
      icon: FaShieldAlt,
      title: t('privacy.responsible'),
      content: (
        <div className="space-y-2">
          <p className="text-gray-300">{t('privacy.responsibleText')}</p>
          <div className="mt-3 p-4 bg-dark-800/50 rounded-xl border border-dark-700/50">
            <p className="font-semibold text-white">KennzeichenPro24 GmbH</p>
            <p className="text-gray-400">Zollstock 15</p>
            <p className="text-gray-400">37081 Göttingen-Grone</p>
            <p className="text-gray-400">Deutschland</p>
            <p className="text-gray-400 mt-2">E-Mail: info@kennzeichenpro24.de</p>
            <p className="text-gray-400">Telefon: +49 (0) 551 49203480</p>
          </div>
        </div>
      ),
    },
    {
      icon: FaDatabase,
      title: t('privacy.overview'),
      content: (
        <div className="space-y-3">
          <p className="text-gray-300">{t('privacy.overviewText')}</p>
          <div>
            <h4 className="text-sm font-semibold text-primary-400 mb-1">{t('privacy.dataTypes')}</h4>
            <p className="text-gray-400 text-sm">{t('privacy.dataTypesList')}</p>
          </div>
        </div>
      ),
    },
    {
      icon: FaFileAlt,
      title: t('privacy.purposes'),
      content: <p className="text-gray-300">{t('privacy.purposesList')}</p>,
    },
    {
      icon: FaGavel,
      title: t('privacy.legalBasis'),
      content: <p className="text-gray-300">{t('privacy.legalBasisText')}</p>,
    },
    {
      icon: FaUserShield,
      title: t('privacy.rights'),
      content: (
        <div className="space-y-2">
          <p className="text-gray-300">{t('privacy.rightsText')}</p>
          <ul className="list-disc list-inside text-gray-400 text-sm space-y-1 mt-2">
            <li>Auskunftsrecht (Art. 15 DSGVO)</li>
            <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
            <li>Recht auf Löschung (Art. 17 DSGVO)</li>
            <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
          </ul>
        </div>
      ),
    },
    {
      icon: FaCookieBite,
      title: t('privacy.cookies'),
      content: <p className="text-gray-300">{t('privacy.cookiesText')}</p>,
    },
    {
      icon: FaServer,
      title: t('privacy.hosting'),
      content: <p className="text-gray-300">{t('privacy.hostingText')}</p>,
    },
    {
      icon: FaEnvelope,
      title: t('privacy.contact'),
      content: <p className="text-gray-300">{t('privacy.contactText')}</p>,
    },
    {
      icon: FaSyncAlt,
      title: t('privacy.changes'),
      content: <p className="text-gray-300">{t('privacy.changesText')}</p>,
    },
  ]

  return (
    <div className="bg-dark-950 min-h-screen py-12 relative overflow-hidden">
      <div className="fixed inset-0 bg-grid-pattern opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-mesh opacity-30"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-10"
          >
            <h1 className="text-4xl md:text-5xl font-black mb-4">
              <span className="text-gradient">{t('privacy.title')}</span>
            </h1>
            <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary-500 to-transparent mx-auto"></div>
          </motion.div>

          <div className="space-y-6">
            {sections.map((section, index) => (
              <motion.section
                key={section.title}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 + index * 0.08, duration: 0.6 }}
                className="card-hover"
              >
                <h2 className="text-xl font-bold mb-4 text-gradient flex items-center gap-3">
                  <section.icon className="w-5 h-5 text-primary-400" />
                  {section.title}
                </h2>
                <div className="text-base leading-relaxed">{section.content}</div>
              </motion.section>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Privacy
